export const openExternal = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
